import { OutlinedButton } from '@/components/layouts/Buttons/OutlinedButton/OutlinedButton';
import { ConfirmDeletionModal } from '@/components/layouts/Modals/ConfirmDeletionModal/ConfirmDeletionModal';
import { PermissionType } from '@/types/auth';
import { EntityType } from '@/types/Organization';
import { useGetPermissionsLevels } from '@/utils/helpers';
import { useState } from 'react';
import s from './DeleteEntity.module.scss';

interface Props {
  isLoading: boolean;
  deleteEntity: () => void;
  entityType: EntityType;
}

export function DeleteEntity({ isLoading, deleteEntity, entityType }: Props) {
  const [isConfirmDeletionModalOpen, setIsConfirmDeletionModalOpen] = useState(false);
  const [, , isAdmin] = useGetPermissionsLevels(PermissionType.Workspace);

  const entityName = entityType === 'workspaces' ? 'Workspace' : 'Organization';

  return (
    <>
      {isAdmin && (
        <>
          <OutlinedButton
            isLoading={isLoading}
            onClick={() => {
              setIsConfirmDeletionModalOpen(true);
            }}
            className={s.leaveButton}
          >
            Delete {entityName}
          </OutlinedButton>
        </>
      )}
      <ConfirmDeletionModal
        title={`Delete ${entityName}`}
        isLoading={isLoading}
        onConfirm={deleteEntity}
        message={`Are you sure you want to delete this ${entityName.toLowerCase()}? This action cannot be reverted.`}
        isOpen={isConfirmDeletionModalOpen}
        setClose={() => setIsConfirmDeletionModalOpen(false)}
      />
    </>
  );
}
